import { render, staticRenderFns } from "./ProjectShift.vue?vue&type=template&id=feefbf40&scoped=true"
import script from "./ProjectShift.vue?vue&type=script&lang=js"
export * from "./ProjectShift.vue?vue&type=script&lang=js"
import style0 from "./ProjectShift.vue?vue&type=style&index=0&id=feefbf40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feefbf40",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QIcon,QTooltip,QCard,QCardSection,QField,QBtn,QSeparator});
